module.exports = __webpack_public_path__ + "img/logo-blue.ffd562fb.svg";